import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'notEmpty'
})
export class NotEmptyPipe implements PipeTransform {

    transform(value: any): any {

        if (this.campoPreenchido(value)) {
            return value;
        }

        return '-';
    }

    private campoPreenchido(campo: string | number | Array<any>): boolean {

        if (campo === undefined || campo == null) {
            return false;
        }

        if (typeof campo === 'string') {
            return campo.trim().length > 0;
        }
        if (campo instanceof Array) {
            return campo.length > 0;
        }

        return true;
    }

}
